import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { CACHE_KEYS } from '../../constants/cache-keys';
import { LPMI_ROUTES } from '../../constants/routes';
import { CacheService } from '../cache.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private cacheService: CacheService,
    private oAuthService: OAuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const isAuthenticated = this.checkAuthentication();

    if (!isAuthenticated) {
      // Redirect to login if not authenticated
      this.router.navigate(['/' + LPMI_ROUTES.LOGIN.PATH], {
        queryParams: { redirectUrl: state.url }
      });
      return false;
    }

    return true;
  }

  private checkAuthentication(): boolean {
    const hasLoginData = !!this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);
    const hasValidAccessToken = this.oAuthService.hasValidAccessToken();

    if (!hasValidAccessToken) {
      // Prevent stale cached role/profile data from allowing protected route access.
      this.cacheService.removeFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);
    }

    return hasLoginData && hasValidAccessToken;
  }
}
